import React, { useState } from 'react';
import { Typography } from '@mui/material';

import BatchSummaryTable from './BatchSummaryTable';
import BatchDetails from '../batchDetails';

const Index = () => {
  const [currentBatch, setCurrentBatch] = useState(null);
  return (
    <div>
      {currentBatch && (
        <Typography variant='h3' align='center'>
          {currentBatch.name}
        </Typography>
      )}
      {currentBatch ? (
        <BatchDetails
          currentBatch={currentBatch}
          setCurrentBatch={setCurrentBatch}
        />
      ) : (
        <BatchSummaryTable setCurrentBatch={setCurrentBatch} />
      )}
    </div>
  );
};

export default Index;
